{
  "en": {
    "copied": "Copied"
  },
  "fr": {
    "copied": "Copié"
  }
}